<template>
  <div class="form-section">
    <!-- 卡片标题 -->
    <h2 class="card-title">{{ $t('msg-congratulations') }}</h2>
    <!-- 卡片部分 -->
    <div class="card">
      <div class="card-logo">
        <img v-if="cardData.bankLogo" :src="cardData.bankLogo" alt="bank logo" />
      </div>
      <div class="card-user">
        <p class="card-user-name">{{ cardData.englishName }}</p>
        <p class="card-user-cardNum">{{ cardData.dragoncode }}</p>
      </div>
      <div class="card-date">
        <p>{{ $t('dragoncard-vaild') }}</p>
        <p v-if="cardData.validData">{{ cardData.validData }}</p>
      </div>
    </div>
    <!-- 描述部分 -->
    <div class="desc">
      <p class="desc1">{{ $t('step4desc1') }}</p>
      <p class="desc2">{{ $t('step4desc2') }}</p>
      <p class="desc3">{{ $t('step4desc3') }}</p>
    </div>
    <!-- 按钮部分 -->
    <Button class="dpi-button dpi-button-primary" @click="goHome">{{ $t('homePage') }}</Button>
  </div>
</template>

<script>
  export default {
    name: 'AddCardSuccess',
    data() {
      return {
        cardData: {},
      };
    },
    mounted() {
      this.cardData = JSON.parse(sessionStorage.getItem('addCardData'));
    },
    methods: {
      goHome() {
        this.$router.push('/');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import './index.scss';
  @import './mobile';
</style>
